import { useRecoilCallback } from 'recoil';
import {
    deformationArrowsEnabledState,
    deformationGridEnabledState,
    deformationHeatmapEnabledState,
} from '~/state/atoms/deformationDisplayAtoms';

// Turns the arrows, grid and displacement heatmap off — the overlays belong to the step that offers them.
export function useResetDeformationOverlays(): () => void {
    return useRecoilCallback(
        ({ reset }) =>
            () => {
                reset(deformationArrowsEnabledState);
                reset(deformationGridEnabledState);
                reset(deformationHeatmapEnabledState);
            },
        []
    );
}
